import { nanoid } from "nanoid";
import { NodeDefConfig } from "src/types/node-def.types";
import type { NodeData, NodeDefinition, NodeType } from "../types/node.types";

export function createNodeDef<TYPE extends NodeType, DATA extends NodeData>(
  config: NodeDefConfig<TYPE, DATA>
): NodeDefinition<TYPE, DATA> {
  const nodeDef: NodeDefinition<TYPE, DATA> = {
    type: config.type,
    displayName: config.displayName,
    shortDisplayName: config.shortDisplayName,
    description: config.description,
    fields: config.fields || [],
    acceptsChildren: config.acceptsChildren,
    autoNodes: config.autoNodes,
    shadowingTree: config.shadowingTree,
    generate: config.generate,
    create: (name?: string, data?: Partial<DATA>) => ({
      id: nanoid(),
      type: config.type,
      name: name || config.defaultName || "",
      data: Object.assign(config.initialData(), data ?? {}),
    }),
  };

  return nodeDef;
}
